import React from 'react'


export const ColorContext = React.createContext()

export const UserContext = React.createContext()